"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
let TOOLTIP_GROUP_DELAY = 1000;
let _preventTransition = false;
let timeoutRef;
const Service = {
  get preventTransition() {
    return _preventTransition;
  },

  setTooltipGroupTimer: function () {
    clearTimeout(timeoutRef);
    _preventTransition = true;
    timeoutRef = setTimeout(() => {
      _preventTransition = false;
    }, TOOLTIP_GROUP_DELAY);
  }
};
var _default = Service;
exports.default = _default;